import { Component, OnInit, EventEmitter,Output, OnDestroy } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit,OnDestroy {
  @Output() sidenavToggle = new EventEmitter <void> ();
  isAuth: boolean=false;
  authSubscription: Subscription;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authSubscription= this.authService.authChange.subscribe(authStatus => {
      this.isAuth= authStatus
    });
  }
  onToggleSidenav() {
    this.sidenavToggle.emit();
  }

  onLogout() {
    this.authService.logout();
    this.router.navigate(['login'])
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
}
